import { EventKeyBettingOffer } from "@gp/models";

export function filterOffer() {
	const isOfferHistoryValid = (offer: EventKeyBettingOffer) =>
		offer.status != null;
	const isValidBettingOffer = (offer: EventKeyBettingOffer) =>
		offer.value > 1;

	const filterOffersByTeam = (
		teamId: string | undefined,
		offers: EventKeyBettingOffer[],
		isValid: (offer: EventKeyBettingOffer) => Boolean
	) => {
		return offers.filter((offer) => {
			const isCorrectTeam = offer.teamId === teamId;

			return isCorrectTeam && isValid(offer);
		});
	};
	return { isValidBettingOffer, isOfferHistoryValid, filterOffersByTeam };
}
